import { useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../AuthContext";

const TILL_RETURN_PARAMS = ["tillStatus", "transId", "orderId", "ref", "isSaveCard"];
const SETTLE_STASH_KEY = "payAccountTillSettle";
const UI_STASH_KEY = "payAccountTillUi";

const writeStash = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data || {}));
  } catch (err) {
    /* storage unavailable */
  }
};

const takeStash = (key, transId) => {
  try {
    const raw = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.transId && transId && String(parsed.transId) !== String(transId)) return null;
    return parsed;
  } catch (err) {
    return null;
  }
};

export const stashPayAccountSettleData = (data) => writeStash(SETTLE_STASH_KEY, data);

export const stashPayAccountUiState = (data) => writeStash(UI_STASH_KEY, data);

export const takePayAccountUiState = (transId) => takeStash(UI_STASH_KEY, transId);

export const readPayAccountTillReturn = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const tillStatus = params.get("tillStatus");
    if (!tillStatus) return null;
    return {
      tillStatus,
      transId: params.get("transId") || "",
      orderRef: params.get("ref") || "",
      isSuccess: tillStatus === "success" || tillStatus === "successSave",
    };
  } catch (err) {
    return null;
  }
};

const stripTillParams = () => {
  try {
    const url = new URL(window.location.href);
    TILL_RETURN_PARAMS.forEach((key) => url.searchParams.delete(key));
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  } catch (err) {
    /* history unavailable */
  }
};

export const usePayAccountTillReturn = () => {
  const [tillReturn] = useState(() => readPayAccountTillReturn());
  const [settling, setSettling] = useState(() => tillReturn != null);
  const [settleFailed, setSettleFailed] = useState(false);
  const [paidInvoices, setPaidInvoices] = useState(null);
  const { userId, companyId, emailAddress, userName, phoneNumber } = useAuth();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!tillReturn || startedRef.current) return;
    startedRef.current = true;

    const stash = takeStash(SETTLE_STASH_KEY, tillReturn.transId) || {};

    axiosInstance
      .post("PayAccount/TillPaymentResponse", {
        transactionID: tillReturn.transId,
        isSaveCard: tillReturn.tillStatus === "successSave",
        status: tillReturn.isSuccess ? tillReturn.tillStatus : "faild",
        companyId: stash.companyId ?? (companyId != null ? String(companyId) : "0"),
        userId: stash.userId ?? String(userId ?? ""),
        userName: stash.userName ?? userName ?? "",
        email: stash.email ?? emailAddress ?? "",
        phone: stash.phone ?? phoneNumber ?? "",
        totalAmount: stash.totalAmount ?? "",
        isProforma: !!stash.isProforma,
      })
      .then((response) => {
        if (response && response.data && response.data.status === 200) {
          setPaidInvoices(response.data.data);
        }
      })
      .catch(() => setSettleFailed(true))
      .then(() => {
        stripTillParams();
        setSettling(false);
      });
  }, [tillReturn]);

  return { settling, settleFailed, tillReturn, paidInvoices };
};
